import React from "react";
import { FaEnvelope, FaPhone } from "react-icons/fa";

const Contact = () => {
  const handleEmailClick = (e) => {
    e.preventDefault();
    const email = "filleez@villanova.edu";
    const gmailUrl = `https://mail.google.com/mail/?view=cm&fs=1&to=${email}`;
    window.open(gmailUrl, "_blank");
  };

  return (
    <div id="contact" className="w-full p-8 mt-24">
      <div className="max-w-5xl mx-auto flex flex-wrap justify-center gap-12">
        {/* Email Box */}
        <div className="w-96">
          <div
            onClick={handleEmailClick}
            className="block p-16 text-center rounded-lg border-2 border-designColor hover:-translate-y-3 transition-all duration-300 bg-gradient-to-r from-bodyColor to-[#202327] group hover:bg-gradient-to-b hover:from-designColor/20 hover:to-purple-900/20 cursor-pointer shadow-shadowOne hover:shadow-2xl hover:border-purple-500"
          >
            <FaEnvelope className="w-14 h-14 mx-auto text-designColor mb-6" />
            <h3 className="text-3xl font-bold mb-4 text-designColor">Email</h3>
            <p className="text-xl text-designColor">fhilleez@gmail.com</p>
          </div>
        </div>

        {/* Phone Box */}
        {/* <div className="w-96">
          <a
            href="tel:+18565807997"
            className="block p-16 text-center rounded-lg border-2 border-designColor hover:-translate-y-3 transition-all duration-300 bg-gradient-to-r from-bodyColor to-[#202327] group hover:bg-gradient-to-b hover:from-designColor/20 hover:to-purple-900/20 cursor-pointer shadow-shadowOne hover:shadow-2xl hover:border-purple-500"
          >
            <FaPhone className="w-14 h-14 mx-auto text-designColor mb-6" />
            <h3 className="text-3xl font-bold mb-4 text-designColor">Phone</h3>
            <p className="text-xl text-designColor">+1 856-580-7997</p>
          </a>
        </div> */}
      </div>
    </div>
  );
};

export default Contact;
